
import { defineComponent } from 'vue';

export default defineComponent({
  name: "operacoes-table",
  components: {

  },
    props: {
      rows: {
        type: Array,
        default: () => {
          [];
        },
      },
      getUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      salvarUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      deleteUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      searchCall: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      operadores: {
        type: Array,
        default: () => {
          [];
        },
      },
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
        searchIKey: '',
        searchQuery:'',
        searchItem:false
      }
    },
    methods: {
      // Método para alternar a ordenação
      searchData(key:any) {
        if (this.searchIKey === key) {
          this.searchItem = !this.searchItem; // Alterna a direção da ordenação
        } else {
          this.searchIKey = key;
          this.searchItem = true; // Se mudar a chave, a ordenação será ascendente por padrão
        } 
      },  

    },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`
      const getUnico = (row: any) => {
          props.getUnico(row); // Define o novo cen tro do mapa
      };

      const salvarUnico = (data:any) => {
          props.salvarUnico(data); // Define o novo cen tro do mapa
      };

      const deleteUnico = (row: any) => {
          props.deleteUnico(row); // Define o novo cen tro do mapa
      };

      const searchCall = (field:any, termo:any) => {
        props.searchCall(field, termo); // Define o novo cen tro do mapa
      };

      
      // Retorna os métodos ou variáveis que você quer expor
      return {
        getUnico,
        salvarUnico,
        deleteUnico,
        searchCall,
      };

    }

});
